import React from 'react';

import PageLayout from '../../../components/PageLayout';

import InheritanceSalvage from './InheritanceSalvage';

async function action() {
  return {
    title: 'Inheritance Salvage',
    description:
      'Flux Tech | Inheritance Salvage - Hidden jems from our store to your home',
    chunks: ['inheritance-salvage'],
    component: (
      <PageLayout>
        <InheritanceSalvage />
      </PageLayout>
    ),
  };
}

export default action;
